
import {AppSettings} from '../AppSettings'

export class TokenRefresher {
static isWaitingResult = false;
promise : Promise<boolean>
static refreshener : TokenRefresher;
    constructor() {
        this.promise = TokenRefresher.createPromise();
    }

    static createPromise() : Promise<boolean> {
        return new Promise(function (resolve) {
            TokenRefresher.refreshToken().then(() => true);
        })
    }

    static refresh = async () => {
        if (!TokenRefresher.refreshener) {
            this.refreshener = new TokenRefresher();
        }
        else if (!TokenRefresher.isWaitingResult) {
            TokenRefresher.refreshener.promise = TokenRefresher.createPromise();
        }
        return TokenRefresher.refreshener.promise;
    }

    static refreshToken = async () => {
        TokenRefresher.isWaitingResult = true;
        const url = `${AppSettings.apiBase}auth/refreshToken`;

        const response = await fetch(url, {
            method : 'POST', 
            credentials: 'include'
        });
        if(response.ok) {
            const data = await response.json();
            console.log('Токен обновлен');
            if (data.success) {
                localStorage.setItem('token', JSON.stringify(data.token));
                TokenRefresher.isWaitingResult = false;
                return true;
            }
        }
        TokenRefresher.isWaitingResult = false;
        localStorage.removeItem("token");
        localStorage.removeItem("role");
        localStorage.removeItem("iconProfile");    
        window.location.reload();
        return false;
    }
}
